window.addEventListener('load', function () {
    const tabContainers = document.querySelectorAll('[data-tab-container]');

    for (const tabContainer of tabContainers) {
        let isAnimating = false;

        tabContainer.addEventListener('click', (event) => {
            const clickedTabItem = event.target;

            if (clickedTabItem.hasAttribute('data-tab-item') && !isAnimating) {
                const tabDataTemplate = clickedTabItem.querySelector('template[data-tab-template-data]');
                const visibleTabContainer = tabContainer.querySelector('[data-visible-tab]');
                const visibleTabContent = tabContainer.querySelector('[data-visible-tab] > div');
                const isTabActive = clickedTabItem.dataset.active === 'true';

                const tabItemHtml = tabDataTemplate.innerHTML;
                const newTabContent = document.createElement('div');
                newTabContent.classList.add('flex', 'flex-grow');
                newTabContent.innerHTML = tabItemHtml;

                if (!isTabActive) {
                    // Close all Tabs
                    tabContainer.querySelectorAll('[data-tab-item]').forEach((tabItem) => {
                        tabItem.dataset.active = 'false';
                    });

                    // Set current card to active
                    clickedTabItem.dataset.active = 'true';

                    // Close container before updating
                    visibleTabContainer.dataset.visible = 'false';
                    isAnimating = true;
                    setTimeout(() => {
                        visibleTabContent.innerHTML = '';
                        visibleTabContent.appendChild(newTabContent);
                        visibleTabContainer.dataset.visible = 'true';
                    }, 300);
                    setTimeout(() => {
                        isAnimating = false;
                    }, 500);
                }
            }
        });
    }
});